import * as Yup from 'yup';
import {
  isRequired,
  personalDetails,
  addressDetails,
  confirmation,
  securityDetails,
  disqualification,
} from '@/utils/schemas/common';
import { isValidDate } from '../helpers';

const schema = {
  licence_type: isRequired('1', 'Licence Type'),
  possess_licence: isRequired('1', 'Question'),
  licence_status: Yup.string()
    .nullable()
    .when(['step', 'possess_licence'], {
      is: (step, possess_licence) =>
        step === '1' && possess_licence === 'possess_licence_no',
      then: Yup.string().required(`Licence Status is required`),
    }),
  driver_number: Yup.string().when('step', {
    is: (value) => value === '1',
    then: Yup.string()
      .min(
        16,
        'Driver’s Licence Number must be 16 characters Or 16 characters + 2 digits'
      )
      .max(
        18,
        'Driver’s Licence Number must be 16 characters Or 16 characters + 2 digits'
      )
      .required('Driver’s Licence Number is required')
      .matches(/^[a-zA-Z0-9]*$/, 'No spaces or special characters are allowed'),
  }),
  licence_expiry_date_day: isRequired('1', 'Day'),
  licence_expiry_date_month: isRequired('1', 'Month'),
  licence_expiry_date_year: isRequired('1', 'Year').test(
    'expiry_date',
    'Please enter a valid date',
    function (year) {
      const month = this.parent.licence_expiry_date_month;
      const day = this.parent.licence_expiry_date_day;
      return isValidDate(`${year}-${month}-${day}`, 'YYYY-MM-DD');
    }
  ),
  legal_eyesight: Yup.string().when('step', {
    is: (value) => value === '1',
    then: Yup.string().nullable().required('Question is required'),
  }),
  wear_glasses: Yup.string().when('step', {
    is: (value) => value === '1',
    then: Yup.string().nullable().required('Question is required'),
  }),
  has_conditions: isRequired('1', 'Question'),
  medical_conditions: Yup.array()
    .of(Yup.string())
    .when('has_conditions', {
      is: (value) => value === 'has_conditions_yes',
      then: Yup.array()
        .of(Yup.string())
        .required('At least one answer is required'),
    }),

  ...disqualification,
  ...personalDetails,
  ...addressDetails,
  ...securityDetails,
  ...confirmation,
};

export const renewalOldSchema = Yup.object().shape(schema);
